import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { useEgiftSalesV2 } from "./hooks/useEgiftSalesV2";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "egiftSalesReport.info.title",
  rows: [
    "egiftSalesReport.info.clinicEgiftSales",
    "egiftSalesReport.info.providerEgiftSales",
  ],
};

const EgiftSalesV2 = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useEgiftSalesV2(requestParams);

  const isClinicDataEmpty = !isLoading && !data?.clinicEgiftSales?.length;
  const isProviderDataEmpty = !isLoading && !data?.providerEgiftSales?.length;

  const providerData = useMemo(
    () =>
      data?.providerEgiftSales?.map((provider) => ({
        providerName: provider.provider_name,
        egiftSales: provider.total_egift_sales,
      })) || [],
    [data],
  );

  const clinicData = useMemo(
    () =>
      data?.clinicEgiftSales?.map((clinic) => ({
        clinicName: clinic.clinic_name,
        egiftSales: clinic.total_egift_sales,
      })) || [],
    [data],
  );

  const _clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="eGift Sales V2"
        selectedClinic={selectedClinic}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getEgiftSalesV2()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex flex-col gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Provider Name", accessor: "providerName" },
              { data: "eGift Sales", accessor: "egiftSales" },
            ]}
            data={providerData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isProviderDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Clinic Name", accessor: "clinicName" },
              { data: "eGift Sales", accessor: "egiftSales" },
            ]}
            data={clinicData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isClinicDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default EgiftSalesV2;
